import { render, staticRenderFns } from "./settleDetails.vue?vue&type=template&id=7c387fdc&scoped=true"
import script from "./settleDetails.vue?vue&type=script&lang=ts"
export * from "./settleDetails.vue?vue&type=script&lang=ts"
import style0 from "./settleDetails.vue?vue&type=style&index=0&id=7c387fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c387fdc",
  null
  
)

export default component.exports